<template>
	<MhRouterView class="DevView view maxWidth maxWidth--appBody" :isContentReady="isContentReady">

		<div class="DevView__inner view__inner">

			<br /><strong>DevView.vue</strong><hr />

			<div class="flex flex--spaceBetween background background--whiteBg" style="padding: 1em;">
				<div class="" style="width: 48%;">
					<BaseMultiSelect
						:label="'Bitte wählen ...'"
						:value="testBaseSelectValues"
						:debug="true"
						:options="[
							'Berlin',
							'Dresden',
							'Leipzig',
							'Hamburg',
							'Moritzburg',
							'Stuttgart',
							'Hildesheim',
							'Frankfurt',
							'Grimma',
							'Chemnitz',
							'Mittweida',
							'Hof',
							'Bern',
							'Gera',
							'Jena',
						]"
						:chunkSize="5"
						:disabled="false"
					></BaseMultiSelect>
					<pre>{{testBaseSelectValues}}</pre>
				</div>
				<div class="" style="width: 48%;">
					<!--
					<BaseSelect
						:label="'Bitte wählen ...'"
						:multiple="true"
						:value="[]"
						:options="doc.getThesauriByKey( 'objekttyp' )"
						:slice="250"
						:disabled="false"
					></BaseSelect>
					-->
				</div>
			</div>

			<br/>

			<DevDocTable :doc="app.doc"></DevDocTable>

			<hr /><br />
			<OutlinedLabel>Default</OutlinedLabel> &nbsp;
			<OutlinedLabel type="error">Fehler</OutlinedLabel> &nbsp;
			<OutlinedLabel type="ok">OK</OutlinedLabel> &nbsp;

			<hr /><br />
			<BaseIcon></BaseIcon> &nbsp;
			<BaseIcon type="arrow-left"></BaseIcon> &nbsp;
			<BaseIcon type="arrow-right"></BaseIcon> &nbsp;
			<BaseIcon type="download"></BaseIcon> &nbsp;
			<BaseIcon type="upload"></BaseIcon> &nbsp;
			<hr /><br />

			<div style="color: red">

				<a class="circleIcon">
					<BaseIcon type="copy-and-paste"></BaseIcon>
				</a> &nbsp;
				<a class="circleIcon">
					<BaseIcon type="cross"></BaseIcon>
				</a> &nbsp;
				<a class="circleIcon">
					<BaseIcon type="triangle-down"></BaseIcon>
				</a>

				&nbsp; &nbsp; &nbsp;

				<a class="circleIcon circleIcon--isDisabled">
					<BaseIcon type="copy-and-paste"></BaseIcon>
				</a> &nbsp;
				<a class="circleIcon circleIcon--isDisabled">
					<BaseIcon type="cross"></BaseIcon>
				</a> &nbsp;
				<a class="circleIcon circleIcon--isDisabled">
					<BaseIcon type="triangle-down"></BaseIcon>
				</a>

			</div>

			<hr />

			<div style="color: green">

				<a class="circleIcon">
					<BaseIcon type="copy-and-paste"></BaseIcon>
				</a> &nbsp;
				<a class="circleIcon">
					<BaseIcon type="cross"></BaseIcon>
				</a> &nbsp;
				<a class="circleIcon">
					<BaseIcon type="triangle-down"></BaseIcon>
				</a>

				&nbsp; &nbsp; &nbsp;

				<a class="circleIcon circleIcon--isDisabled">
					<BaseIcon type="copy-and-paste"></BaseIcon>
				</a> &nbsp;
				<a class="circleIcon circleIcon--isDisabled">
					<BaseIcon type="cross"></BaseIcon>
				</a> &nbsp;
				<a class="circleIcon circleIcon--isDisabled">
					<BaseIcon type="triangle-down"></BaseIcon>
				</a>

			</div>

			<hr /><br />

			<BaseButton>
				<template v-slot:before>before</template>
				BaseButton
				<template v-slot:after>
					<BaseIcon type="arrow-right"></BaseIcon>
				</template>
			</BaseButton>

			<hr /><br />

			<BaseButton>
				<template v-slot:before></template>
				BaseButton
				<template v-slot:after>
					<BaseIcon type="download"></BaseIcon>
				</template>
			</BaseButton> &nbsp;
			<BaseButton :isDisabled="true">isDisabled</BaseButton> &nbsp;
			<BaseButton :isDisabled="true" :isOutlined="true">BaseButton</BaseButton> &nbsp;
			<BaseButton :isOutlined="true">BaseButton--isOutlined</BaseButton> &nbsp;
			<!--
			-->

			<hr /><br />

			<DocEditForm></DocEditForm>

		</div>

	</MhRouterView>
</template>

<script>
	// @ is an alias to /src
	import { EventBus } from '@/event-bus.js' // TODO: remove this
	//import RestHandler from '@/components/RestHandler/RestHandler.js'
	import MhRouterView from './../components/MhRouterView/v2/MhRouterView.vue'

	import DevDocTable from './../components/CSGIS/DevDocTable.vue'
	import BaseButton from '../components/CSGIS/BaseButton.vue'

	import BaseMultiSelect from '/Users/Mario/Dropbox/htdocs/2020-09-17__MhForm/vue-cli-dev/src/components/MhForm/v3/BaseMultiSelect.vue'
	import BaseIcon from './../components/CSGIS/BaseIcon.vue'
	import OutlinedLabel from './../components/CSGIS/OutlinedLabel.vue'

	import DocEditForm from '../components/CSGIS/DocEditForm.vue'

	//import MhRouterView from './../components/MhRouterView/v2/MhRouterView.vue'

	export default {
		name: 'DevView',
		components: {
			MhRouterView,

			DevDocTable,
			BaseButton,

			BaseMultiSelect,
			BaseIcon,
			OutlinedLabel,

			DocEditForm,
		},
		mixins: [],
		directives: {},
		props: {},
		data() {
			return {
				isContentReady       : false,
				testBaseSelectValues : [],
			}
		},
		computed: {
			app(){
				return this.$root.$children[0]
			},
			elmClasses(){
				let classes = []

				//classes.push('new_class')

				return classes
			},
			doc(){
				return this.app.doc
			},
		},
		methods: {},
		mounted(){
			this.isContentReady = true
		},
	}
</script>

<style lang="less">
	@import (reference) "../less/vars.less";
	@import (reference) "../less/mixins.less";
	@import (reference) "../less/atoms.less";

	.BaseButton {
		--fontWeight : 500;

		--borderColor : @swatches[primary];

		--filled-bgColor   : @swatches[primary];
		--filled-textColor : white;

		--outlined-bgColor   : @swatches[primaryLighter];
		--outlined-textColor : @swatches[primary];

		--hover-color            : @swatches[primaryDarker];
		--hover-outlined-bgColor : @swatches[primaryLight];
		--active-outlined-bgColor: @swatches[primaryLight];
	}

	.DevView {
		&__inner {
			//padding: 1rem;
		}
	}

	@media @mediaQueries[xs] {}
	@media @mediaQueries[sm] {}
	@media @mediaQueries[md] {}
	@media @mediaQueries[dt] {}
	@media @mediaQueries[lg] {}
	@media @mediaQueries[xl] {}
</style>
